import * as R from 'ramda';
import { normalizeThemeName } from '../theme';

class Resources {
  // Resources :: XML -> Resources
  constructor (custom, themeConfig = {}) {
    this.customMapped = new Set(customMappings(custom));
    this.themeConfig = themeConfig;
  }

  // Resources#get :: String -> String
  get (id) {
    return this.hasCustom(id) ? `#custom--${id}` : `#${id}`;
  }

  // Resources#hasCustom :: String -> Boolean
  hasCustom (id) {
    return this.customMapped.has(id);
  }
}

// customMappings :: XML -> [String]
const customMappings = R.compose(
  R.map(([_, id]) => id),
  R.map(R.match(/id="custom--([^"]+)"/)),      // pick id
  R.match(/<symbol[^>]*id="custom--([^"]+)"/g) // pick all matches
);

// symbolsURL :: AppContext -> String
const symbolsURL = ({ imdHash }) => `/${imdHash}/client/dist/sprite.symbol.svg`;

// customsymbolsURL :: AppContext -> String
const customsymbolsURL = ({ imdSettings }) => {
  const { theme = '' } = imdSettings;
  const themeName = normalizeThemeName(theme);
  return `/theme-res/dist/${themeName}.symbol.svg`;
};

// load :: HTMLElement -> Url -> Promise XML
const loadSymbolResources = target => url => fetch(url)
  .then(response => response.ok ?
    response.text() :
    `<svg style="display: none">No resources: ${url}</svg>`)
  .then(svg => (target.insertAdjacentHTML('afterbegin', svg), svg));

// loadThemeConfig :: AppContext -> String
const loadThemeConfig = ({ imdSettings }) => {
  const { theme = '' } = imdSettings;
  return fetch(`/theme-res/${theme}/resources/config.json`)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      console.warn(`Theme '${theme}' has no config.json`);
      return {};
    })
    .catch(_ => {
      console.warn(`Loading theme '${theme}' config.json failed`);
      return {};
    });
};

// load :: (AppContext, HTMLElement) -> Promise Resources
const load = (context, target) => {
  return Promise.all(
    [
      symbolsURL(context),
      customsymbolsURL(context)
    ].map(
      loadSymbolResources(target)
    )
      .concat(
        loadThemeConfig(context)
      )
  )
    .then(([_, custom, config]) => new Resources(custom, config));
};

export default {
  load
};
